<template>
  <p
    v-if="promo && me.office_type === 'member'"
    class="fixed bottom-10 left-0 w-full z-9999 animate-marque-sm text-xs font-bold cursor-pointer sm:animate-marque-md lg:animate-marque-lg"
    @click="onClick"
  >
    Promo berjalan {{ promo.attributes.name }} {{ promo.attributes.stockist_start_at | formatDate }} - {{ promo.attributes.stockist_start_at | formatDate }} mengikuti stockist selama stock promo di stockistnya ada (tidak ada talangan/reimburse)
  </p>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { requestMixin } from '../mixins/request/request';

export default {
  mixins: [requestMixin],
  data() {
    return {
      promo: null
    }
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getMenus: 'menus/getMenus',
    })
  },
  methods: {
    ...mapMutations({
      setMenu: 'auth/setMenu',
    }),
    async loadPromo()  {
      const [res, err] = await this.request(`/api/v1/product-promos`, {
        params: {
          'filter[is_started]': true,
          'filter[is_finished]': false
        }
      })

      if (!err && res.data.length > 0) {
        this.promo = res.data[0]
      }
    },
    onClick() {
      this.setMenu(this.getMenus.data.find(it => it.attributes.name === 'Cashbill' && it.attributes.parent_id === null))

      this.$router.push({ name: 'cashbill' })
    }
  },
  created() {
    this.loadPromo()
  }
}
</script>